import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import 'rxjs/add/observable/of';

import { RESTService } from '../../services/rest.service';
import { promise } from 'protractor';

@Injectable()
export class SubscriptionService extends RESTService<any> {

    private tokenPayload: any;
    private currentUserId: number;

    constructor(http: HttpClient, authService: NbAuthService) {
        super(http, authService);
        this.authService.onTokenChange()
            .subscribe((token: NbAuthJWTToken) => {
                if (token.getValue()) {
                    const JWTToken  = new NbAuthJWTToken(token.getValue());
                    //JWTToken.setValue(token.getValue());

                    const tokenPayload = JWTToken.getPayload();
                    this.currentUserId = tokenPayload.id;
                }
            });
    }

    //GET ALL
    public GetSubscription(
        id: any,
    ): Promise<any> {
        this.setApiEndpoint('/SubscripcionEdo?companyid=' + id);
        return this.getAll();
    }

    // SAVE
    public SaveSubscription(
        data: any,
    ): Promise<any> {
        this.setApiEndpoint('/SubscripcionEdo');
        return this.save(data);
    }

    // PUT
    public updateSubscription(data: any): Promise<any> {
        this.setApiEndpoint('/SubscripcionEdo');
        return this.update(data);
    }

    // DELETE
    public deleteSubscription(id: number): Promise<boolean> {
        this.setApiEndpoint('/SubscripcionEdo');
        return this.delete(id);
    }

		public getSubscriptionEmails(): Promise<any> {
				this.setApiEndpoint('/CorreosMeteorologicos');
				return this.getOne();
		}

		public addEmail(data: any): Promise<any> {
        this.setApiEndpoint('/CorreosMeteorologicos');
        return this.save(data);
    }
		
		public deleteEmailSubscription(data: any): Promise<any> {
        this.setApiEndpoint('/CorreosMeteorologicos');
        return this.deletev3(data);
    }

    public newResource(data: any): any {
        return this, data;
    }
}
